import { find, head, get } from "lodash";

export default plaidResponse => {
  const accounts = [];

  // Collect all accounts from all PlaidItems
  for (let i = 0; i < plaidResponse.length; i++) {
    accounts.push(...get(plaidResponse[i], "accounts", []));
  }

  // Find the default account across all PlaidItems
  const defaultAccount = find(accounts, account => account.default === true);
  
  // Find the PlaidItem that owns the default account
  // This is the "overarching account" we should use for identity data
  let defaultPlaidItem = head(plaidResponse); // Fallback to first if no default found
  
  if (defaultAccount) {
    // Find which PlaidItem contains this default account
    for (let i = 0; i < plaidResponse.length; i++) {
      const plaidItemAccounts = get(plaidResponse[i], "accounts", []);
      const hasDefaultAccount = plaidItemAccounts.some(acc => acc.id === defaultAccount.id);
      if (hasDefaultAccount) {
        defaultPlaidItem = plaidResponse[i];
        break;
      }
    }
  }

  // Get identity data from the PlaidItem associated with the default account
  const name = get(defaultPlaidItem, "names", "");

  const phone = get(
    find(
      get(defaultPlaidItem, "phone_numbers", []),
      phone => phone.primary === true
    ),
    "phone_number",
    ""
  );

  const email = get(
    find(
      get(defaultPlaidItem, "emails", []),
      email => email.primary === true
    ),
    "email_id",
    ""
  );

  const address = find(
    get(defaultPlaidItem, "addresses", []),
    address => address.primary === true
  );

  const created = get(defaultPlaidItem, "created", "");

  const street = get(address, "street", "");
  const city = get(address, "city", "");
  const state = get(address, "state", "");
  const zip = get(address, "zip_code", "");

  const bankAccount = get(defaultAccount, "account_number_redacted", "");
  const bankName = get(defaultAccount, "bank_name", "");
  const routingNumber = get(defaultAccount, "routing_number", "");

  const accountEntryMethod = get(defaultPlaidItem, "account_entry_method", "manually");

  return {
    accounts,
    name,
    email,
    bankAccount,
    bankName,
    phone,
    routingNumber,
    address: street,
    city,
    state,
    zip,
    created,
    accountEntryMethod,
  };
};
